import { DetailField, Tag } from "@/modules/common/components";
import {
  MANAGEMENT_COMPANY_STATUS_OPTIONS,
  MANAGEMENT_MODEL_OPTIONS,
  MANAGEMENT_USAGE_TYPE_OPTIONS,
  ManagementCompanyStatus,
  ManagementCompanyUsageType,
} from "@/modules/common/types/ManagementCompanies.enum";
import { formatCnpj } from "@/modules/common/utils/format";
import { AdminManagementCompanyResponse } from "@/service/response/admin-management-companies";

interface GeneralDataTabProps {
  company: AdminManagementCompanyResponse;
}

const GeneralDataTab = ({ company }: GeneralDataTabProps) => {
  const isActiveStatus = company.status === ManagementCompanyStatus.ACTIVE;
  const isProductionType = company.usageType === ManagementCompanyUsageType.PRODUCTION;
  const statusLabel = MANAGEMENT_COMPANY_STATUS_OPTIONS.find((option) => option.value === String(company.status))?.label ?? "-";
  const usageTypeLabel = MANAGEMENT_USAGE_TYPE_OPTIONS.find((option) => option.value === String(company.usageType))?.label ?? "-";

  return (
    <div className="flex flex-col gap-4 rounded-xl bg-white p-4">
      <div className="flex flex-col">
        <p className="text-[16px] font-bold text-ui-primary">Dados Gerais</p>
        <p className="text-[12px] text-ui-text-muted">Informações cadastrais da gestora.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <DetailField label="Nome Fantasia">{company.name}</DetailField>
        <DetailField label="Razão Social">{company.corporateName}</DetailField>

        <DetailField label="Modelo de Gestão">
          {MANAGEMENT_MODEL_OPTIONS.find((option) => option.value === String(company.managementModel))?.label}
        </DetailField>
        <DetailField label="Status">
          <Tag label={statusLabel} variant={isActiveStatus ? "success" : "neutral"} className="border-0 py-0" />
        </DetailField>

        <DetailField label="Tipo da Gestora">
          <Tag label={usageTypeLabel} variant={isProductionType ? "success" : "neutral"} className="border-0 py-0" />
        </DetailField>

        <DetailField label="CNPJ">{company.cnpj ? formatCnpj(company.cnpj) : null}</DetailField>
        <DetailField label="E-mail Principal">{company.email}</DetailField>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          <p className="text-[16px] font-bold text-ui-primary">Representante</p>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <DetailField label="Nome">{company.owner?.name}</DetailField>
          <DetailField label="Email">{company.owner?.email}</DetailField>
        </div>
      </div>
    </div>
  );
};

export default GeneralDataTab;
